import React, { Fragment } from 'react';
import { bool, string } from 'prop-types';

import Bride from '@assets/images/DUC_7941-01-square-huong.jpeg';
import Groom from '@assets/images/DUC_8566-01-square.jpeg';

import { styWrapper } from './styles';

function HelloSection({ isInvitation, guestName }) {
  return (
    <Fragment>
      <div id="fh5co-couple" css={styWrapper}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
              <h2 className="main-font">Trân trọng kính mời</h2>
              <p className="info">
                Tuấn & Hương trân trọng kính mời anh, chị, em, bạn bè thân hữu cùng người thân, người thương đến tham dự
                lễ cưới của hai vợ chồng chúng em
              </p>
            </div>
          </div>
          <div className="couple-wrap">
            <div className="couple-half">
              <div className="groom">
                <img src={Groom} alt="groom" className="img-responsive" loading="lazy" />
              </div>
              <div className="desc desc-groom">
                <h3 className="main-font">
                  Phạm <br />
                  Thanh Tuấn
                </h3>
                {/* <p className="parent-name parent-name__top">
                  Putri Bapak Totok Somo Dipoyono <br />& Ibu Setyo Listiani
                </p> */}
              </div>
            </div>
            <p className="heart text-center">
              <i className="icon-heart2"></i>
            </p>
            <div className="and-love">
              <i className="icon-heart2"></i>
            </div>
            <div className="couple-half">
              <div className="bride">
                <img src={Bride} alt="bride" className="img-responsive" loading="lazy" />
              </div>
              <div className="desc desc-bride">
                <h3 className="main-font">
                  Vương Ngọc
                  <br />
                  Quỳnh Hương
                </h3>
                {/* <p className="parent-name">
                  Putra Bapak Bunari <br />& Ibu Suratun
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

HelloSection.propTypes = {
  isInvitation: bool.isRequired,
  guestName: string,
};

export default HelloSection;
